import * as types from "../mutation-types";

// annualFeePayFrequency
// 0 - None
// 1 - Monthly
// 3 - Quarterly
// 6 - SemiAnnually
// 12 - Annually
// 24 - Biennially
// 365 - Daily
const annualFeeChargeFrequencyOptions = [
    { labelId: "COMMON_FREQUENCY_MONTHLY", value: 1 },
    { labelId: "COMMON_FREQUENCY_QUARTERLY", value: 3 },
    { labelId: "COMMON_FREQUENCY_SEMI_ANNUALLY", value: 6 },
    { labelId: "COMMON_FREQUENCY_ANNUALLY", value: 12 }
];
const annualFeePayMethodOptions = [
    { labelId: "fees_out_of_pocket", value: 0 },
    { labelId: "fees_sale_of_shares", value: 1 }
];
const annualFeePayOnBeginOptions = [
    { labelId: "fees_end_of_period", value: false },
    { labelId: "fees_beginning_of_period", value: true }
];
const booleanOptions = [
    { labelId: "fees_yes", value: true },
    { labelId: "fees_no", value: false }
];
const feesBooleanOptions = [
    { labelId: "fees_yes", value: 1 },
    { labelId: "fees_no", value: 0 }
];
const variesAcrossHoldingsOptions = [
    { labelId: "fees_yes", value: 1 },
    { labelId: "fees_no", value: 0 },
    { labelId: "COMMON_VAH", value: 2 }
];

function initialState() {
    return {
        includeAdvisoryFee: null,
        includeTransactionFee: null,
        annualFeeAmount: null,
        annualFeeChargeFrequency: null,
        annualFeePayMethod: null,
        annualFeePayOnBegin: null,
        annualFeePayCashFirst: null,
        frontLoadType: 0,
        frontLoadAmountType: null,
        frontLoadAmount: null,
        redemptionCharge: null,
        chargeOnRebalancing: null,
        loi: null // short for 'letter of intent'
    };
}

const state = {
    ...initialState()
};

const getters = {
    annualFeeChargeFrequencyOptions() {
        return annualFeeChargeFrequencyOptions;
    },
    annualFeePayMethodOptions() {
        return annualFeePayMethodOptions;
    },
    annualFeePayOnBeginOptions() {
        return annualFeePayOnBeginOptions;
    },
    feesBooleanOptions() {
        return feesBooleanOptions;
    },
    booleanOptions() {
        return booleanOptions;
    },
    variesAcrossHoldingsOptions() {
        return variesAcrossHoldingsOptions;
    },
    feeSetting(state) {
        if (state.includeAdvisoryFee || state.includeTransactionFee) {
            if (state.frontLoadType === 1) {
                return {
                    includeAdvisoryFee: state.includeAdvisoryFee,
                    includeTransactionFee: state.includeTransactionFee,
                    annualFeeAmount: state.annualFeeAmount,
                    annualFeeChargeFrequency: state.annualFeeChargeFrequency,
                    annualFeePayMethod: state.annualFeePayMethod,
                    annualFeePayOnBegin: state.annualFeePayOnBegin,
                    annualFeePayCashFirst: state.annualFeePayCashFirst,
                    frontLoadType: state.frontLoadType,
                    frontLoadAmountType: state.frontLoadAmountType,
                    frontLoadAmount: state.frontLoadAmount,
                    redemptionCharge: state.redemptionCharge,
                    chargeOnRebalancing: state.chargeOnRebalancing,
                    loi: state.loi
                };
            } else {
                return {
                    includeAdvisoryFee: state.includeAdvisoryFee,
                    includeTransactionFee: state.includeTransactionFee,
                    annualFeeAmount: state.annualFeeAmount,
                    annualFeeChargeFrequency: state.annualFeeChargeFrequency,
                    annualFeePayMethod: state.annualFeePayMethod,
                    annualFeePayOnBegin: state.annualFeePayOnBegin,
                    annualFeePayCashFirst: state.annualFeePayCashFirst,
                    frontLoadType: state.frontLoadType,
                    redemptionCharge: state.redemptionCharge,
                    chargeOnRebalancing: state.chargeOnRebalancing,
                    loi: state.loi
                };
            }
        } else {
            return {
                includeAdvisoryFee: false,
                includeTransactionFee: false
            };
        }
    },
    getPreferenceFeeSetting(state, getters, rootState) {
        return rootState.settings.preferences.feeSetting;
    }
};

const actions = {};

const mutations = {
    [types.UPDATE_FEE_SETTING](state, data) {
        if (data) {
            state.includeAdvisoryFee = data.includeAdvisoryFee;
            state.includeTransactionFee = data.includeTransactionFee;
            state.annualFeeAmount = data.annualFeeAmount;
            state.annualFeeChargeFrequency = data.annualFeeChargeFrequency;
            state.annualFeePayMethod = data.annualFeePayMethod;
            state.annualFeePayOnBegin = data.annualFeePayOnBegin;
            state.annualFeePayCashFirst = data.annualFeePayCashFirst;
            state.frontLoadType = data.frontLoadType;
            state.loi = data.loi;
            state.redemptionCharge = data.redemptionCharge;
            state.chargeOnRebalancing = data.chargeOnRebalancing;
            if (typeof data.frontLoadAmountType !== "undefined") {
                state.frontLoadAmountType = data.frontLoadAmountType;
            }
            if (typeof data.frontLoadAmount !== "undefined") {
                state.frontLoadAmount = data.frontLoadAmount;
            }
        } else {
            state.includeAdvisoryFee = false;
            state.includeTransactionFee = false;
        }
    },
    [types.SET_INCLUDE_ADVISORY_FEE](state, data) {
        state.includeAdvisoryFee = data;
    },
    [types.SET_INCLUDE_TRANSACTION_FEE](state, data) {
        state.includeTransactionFee = data;
    },
    [types.SET_ANNUAL_FEE_AMOUNT](state, data) {
        state.annualFeeAmount = data;
    },
    [types.SET_ANNUAL_FEE_CHARGE_FREQUENCY](state, data) {
        state.annualFeeChargeFrequency = data;
    },
    [types.SET_ANNUAL_FEE_PAY_METHOD](state, data) {
        state.annualFeePayMethod = data;
    },
    [types.SET_ANNUAL_FEE_PAY_ON_BEGIN](state, data) {
        state.annualFeePayOnBegin = data;
    },
    [types.SET_ANNUAL_FEE_PAY_CASH_FIRST](state, data) {
        state.annualFeePayCashFirst = data;
    },
    [types.SET_FRONT_LOAD_TYPE](state, data) {
        state.frontLoadType = data;
    },
    [types.SET_FRONT_LOAD_AMOUNT](state, data) {
        state.frontLoadAmount = data;
    },
    [types.SET_FRONT_LOAD_AMOUNT_TYPE](state, data) {
        if (Number.isInteger(state.frontLoadAmountType) && Boolean(state.frontLoadAmountType !== data)) {
            state.frontLoadAmount = 0;
        }
        state.frontLoadAmountType = data;
        state.frontLoadType = 1;
    },
    [types.SET_LOI](state, data) {
        state.loi = data;
    },
    [types.SET_REDEMPTION_CHARGE](state, data) {
        state.redemptionCharge = data;
    },
    [types.SET_CHARGE_ON_REBALANCING](state, data) {
        state.chargeOnRebalancing = data;
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    }
};

export function checkEqualFrontLoadFees(securities) {
    const firstFrontLoadType = securities[0].fees.frontLoadType;
    const isEqualFrontLoadType = securities.every(security => security.fees.frontLoadType === firstFrontLoadType);
    if (isEqualFrontLoadType) {
        if (firstFrontLoadType === 1) {
            const firstFrontLoadAmountType = securities[0].fees.frontLoadAmountType;
            const firstFrontLoadAmount = securities[0].fees.frontLoadAmount;
            const equalFrontLoadTypes = securities.every(security => security.fees.frontLoadAmountType === firstFrontLoadAmountType);
            const equalFrontLoadAmount = securities.every(security => security.fees.frontLoadAmount === firstFrontLoadAmount);
            return equalFrontLoadTypes && equalFrontLoadAmount;
        }
    }
    return isEqualFrontLoadType;
}

export function isEqualRedemptionChargeFee(securities) {
    const firstRedemptionCharge = securities[0].fees.redemptionCharge;
    return securities.every(security => security.fees.redemptionCharge === firstRedemptionCharge);
}

export default {
    state,
    getters,
    actions,
    mutations
};
